<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-12">
        <v-toolbar dark color="blue-grey">
          <v-toolbar-title>Login</v-toolbar-title>
          <v-spacer></v-spacer>
          <!--
          <v-tooltip right>
            <v-btn slot="activator" icon large href="#" target="_blank">
              <v-icon large>code</v-icon>
            </v-btn>
            <span>Register</span>
          </v-tooltip>
          -->
        </v-toolbar>
        <v-card-text>
          <v-form @submit.prevent="handleSubmit">
            <v-text-field
              prepend-icon="person"
              label="Email"
              type="email"
              v-model="email"
              required
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            ></v-text-field>
            <v-text-field
              prepend-icon="lock"
              label="Password"
              type="password"
              v-model="password"
              required
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="handleSubmit">Login</v-btn>
        </v-card-actions>
        <v-snackbar
          v-model="snackbar"
          :color="error"
          :timeout="10000"
          :top="true"
        >
          {{ error }}
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    props: {
      redirect: {
        type: Object,
        default: () => {
          return {name: 'home'}
        }
      }
    },
    mixins: [validationMixin],
    validations: {
      email: { required, email },
      password: { required }
    },
    data: () => ({
      drawer: null,
      snackbar: false,
      error: "",
      email: "",
      password: ""
    }),
    computed: {
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Must be valid e-mail')
        !this.$v.email.required && errors.push('E-mail is required')
        return errors
      },
      passwordErrors () {
        const errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push('Password is required.')
        return errors
      }
    },
    methods: {
      handleSubmit () {
        this.$v.$touch();

        this.$http.post(this.$http.api.getUrl('/auth/local'), {
          identifier: this.email,
          password: this.password
        })
        .then(response => {
          this.$http.api.user = response.data.user;
          this.$http.api.jwt = response.data.jwt;

          this.$router.push(this.redirect);
        })
        .catch(error => {
          if (error.response.data.message) {
            this.error = 'Error: ' + error.response.data.message;
            this.snackbar = true;
          }
          else {
            console.dir(error);
          }
        });
      }
    }
  }
</script>
